function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ArrayList from '../../../../java/util/ArrayList';
var PriorityQueue = /*#__PURE__*/function () {
  function PriorityQueue() {
    _classCallCheck(this, PriorityQueue);
    PriorityQueue.constructor_.apply(this, arguments);
  }
  return _createClass(PriorityQueue, [{
    key: "poll",
    value: function poll() {
      if (this.isEmpty()) return null;
      var minItem = this._items.get(1);
      this._items.set(1, this._items.get(this._size));
      this._size -= 1;
      this.reorder(1);
      return minItem;
    }
  }, {
    key: "size",
    value: function size() {
      return this._size;
    }
  }, {
    key: "reorder",
    value: function reorder(hole) {
      var child = null;
      var tmp = this._items.get(hole);
      for (; hole * 2 <= this._size; hole = child) {
        child = hole * 2;
        if (child !== this._size && this._items.get(child + 1).compareTo(this._items.get(child)) < 0) child++;
        if (this._items.get(child).compareTo(tmp) < 0) this._items.set(hole, this._items.get(child));else break;
      }
      this._items.set(hole, tmp);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._size = 0;
      this._items.clear();
    }
  }, {
    key: "peek",
    value: function peek() {
      if (this.isEmpty()) return null;
      var minItem = this._items.get(1);
      return minItem;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._size === 0;
    }
  }, {
    key: "add",
    value: function add(x) {
      this._items.add(null);
      this._size += 1;
      var hole = this._size;
      this._items.set(0, x);
      for (; x.compareTo(this._items.get(Math.trunc(hole / 2))) < 0; hole /= 2) {
        this._items.set(hole, this._items.get(Math.trunc(hole / 2)));
      }
      this._items.set(hole, x);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PriorityQueue;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { PriorityQueue as default };
PriorityQueue.constructor_ = function () {
  this._size = null;
  this._items = null;
  this._size = 0;
  this._items = new ArrayList();
  this._items.add(null);
};